export default [
    { 
        id:1.0,
        title : "HOTEL MANAGEMENT",
        description: "Fullstack Hotel Management Using MERN, MongoDB, Expressjs, Reactjs and nodejs"
        ,images: [
            "./Images/Projects/hotelM0.png",
            "./Images/Projects/hotelM1.png",
            "./Images/Projects/hotelM2.png",
            "./Images/Projects/hotelM4.png",
            "./Images/Projects/hotelM5.png",

        ],
        // githubLink: "https://github.com/David-Ramboy/Zombie-Unity.git",
        // linkLive: "https://youtu.be/gXm6ubDOatE"
    },
    { 
        id:1,
        title : "Hero vs Monsters",
        description: "Hero vs Monsters is an endless game created using Unity C# "
        ,images: [
            "./Images/Projects/HerovsMonsters(1).jpg",
        ],
        githubLink: "https://github.com/David-Ramboy/Zombie-Unity.git",
        linkLive: "https://youtu.be/gXm6ubDOatE"
    }, 
    {   
        id: 2,
        title : "Marvel Web page",
        description: "Marvel Webpage design using css html."
        ,images: [
            "./Images/Projects/marvel-page.jpg",
        ],
        githubLink: "https://github.com/David-Ramboy/Movie-page-design",
        linkLive: "https://movie-page-design.pages.dev/"
    }, 
    {   
        id: 2,
        title : "Music Player",
        description: "A small project music player created using Javascript css html."
        ,images: [
            "./Images/Projects/musicPlayer.jpg",
        ],
        githubLink: "https://github.com/David-Ramboy/Music-Player.git",
        linkLive: "https://music-player-github-io.pages.dev/"
    }, 
    { 
        id: 3,
        title : "Book List",
        description: "Using local Storage I created CRUD to store Book to list"
        ,images: [
            "./Images/Projects/BookList.jpg",
        ],
        githubLink: "https://github.com/David-Ramboy/Book-List",
        linkLive: "https://david-ramboy.github.io/deploye.github.io/"
    }, 
    { 
        id: 4,
        title : "Drawing App",
        description: "Small Drawing App project created using html css js"
        ,images: [
            "./Images/Projects/Drawingapp.jpg",
        ],
        githubLink: "https://github.com/David-Ramboy/Drawing-App",
        linkLive: "https://drawing-app-github-io.pages.dev/Drawing-App/"
    },{
        id: 5,
        title : "Jack n Poy",
        description: "a 2player game created using html css js"
        ,images:[ 
            "./Images/Projects/JacknPoy.jpg",   
        ],
        githubLink: "https://github.com/David-Ramboy/Jack-n-Poy",
        linkLive: "https://164109db.jack-n-poy.pages.dev/"
    }
    
]